import { makeAutoObservable, runInAction } from 'mobx'
import { GlobalCopyApi } from '../../core/api/GlobalCopyApi'
import type { MicroInsightsCopy } from '../../core/types/localization'

export class CopyStore {
  copyApi: GlobalCopyApi = new GlobalCopyApi('/', '')
  copyObject: MicroInsightsCopy = {} as MicroInsightsCopy
  namespace = 'experiences'
  translationKey = 'micro_insights'

  constructor() {
    makeAutoObservable(this)
  }

  // NOTE: Not sure if this is special case, but other stores have this deprecation todo
  // DEPRECATED: Initialize api in constructor and use loadCopy instead
  // TODO: Remove this function
  initialize = async (endpoint: string, token: string) => {
    this.copyApi = new GlobalCopyApi(endpoint, token)
    await this.loadCopy()
  }

  loadCopy = async () => {
    const copy = await this.copyApi.getGlobalCopy(this.namespace, this.translationKey)

    runInAction(() => {
      this.copyObject = copy[this.translationKey]
    })
  }

  get cardsCopy(): any {
    return this.copyObject.cards
  }

  get carouselCopy(): any {
    return this.copyObject.carousel
  }

  get zeroStateCopy(): any {
    return this.copyObject.zero_state
  }
}
